'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  ', '\n'], ['\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('@hixme-ui/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StateIndicator = _styledComponents2.default.div(_templateObject, function (props) {
  if (props.state) {
    return props.state === 'WARN' ? 'background: ' + _theme.colorTheme.warning : 'background: ' + _theme.colorTheme.danger;
  }
  return null;
});

exports.default = StateIndicator;
//# sourceMappingURL=StateIndicator.js.map


//////////////////
// WEBPACK FOOTER
// ../tabs/lib/components/StateIndicator.js
// module id = 766
// module chunks = 0